export default __webpack_public_path__ + "static/media/JOSA CLASS-7 EXAM PATTERN 2025.c2e1c994.pdf";